import React, {Fragment, useState} from 'react'
import {ReactComponent as ChevronRight} from '../../assets/icons/chevron-right.svg'
import {ReactComponent as ArrowBack} from '../../assets/icons/arrow_back.svg'
import {useSelectedVariantContext} from './context/SelectedVariantContext'
import {actionChangeDisplay, actionChangeSelectedLayer} from './context/SelectedVariantContext/action'
import {toaster} from '../../shared/PFToast'
import {isBackofficeEnv} from '../../helpers/isBackoffceEnv'
import Publish from './publish/Publish'
import { useEditorStageSides } from '../../hooks/useEditorStageSides'
import { StepIndicator } from '../shopify-mapping/header/MappingHeader'
import { useNavigate } from 'react-router-dom'
import { Tooltip } from 'reactstrap'

const NavBar = ({mappingProductId, variantId, sku}) => {
    const {
        state: {display, pickerAttributes, productDetail, runningImageCompress, productCreatedType, cropMode, designs, mappingProduct, product},
        dispatch,
    } = useSelectedVariantContext()
    const navigate = useNavigate()
    const [tooltipOpen, setTooltipOpen] = useState(false)
    const toggleTooltip = () => setTooltipOpen(!tooltipOpen)
    const stageSides = useEditorStageSides()
    let hasLayers = false
    stageSides.forEach((data) => {
        data.forEach((stage) => {
            const {layers = []} = stage
            if (layers.length > 0) {
                hasLayers = true
            }
        })
    })

    const isDesignStep = display === 'design'
    const isPreviewStep = display === 'preview'
    const isPricingStep = display === 'pricing'

    const toggleDisplay = (_display) => {
        if (_display !== display) {
            dispatch(actionChangeDisplay(_display))
        }
    }

    const switchPreview = () => {
        let invalidDpi = null
        for (const attr of pickerAttributes) {
            const {safeZone} = attr

            for (const [key, value] of Object.entries(safeZone)) {
                const totalInvalidDpi = value.invalidsDpi.length
                if (totalInvalidDpi) {
                    invalidDpi = {
                        side: key,
                        total: totalInvalidDpi,
                    }
                    break
                }
            }
        }
        if (invalidDpi) {
            toaster({
                type: 'error',
                message: `Side ${invalidDpi.side} has ${invalidDpi.total} layer image invalid DPI`,
            })
        } else {
            dispatch(actionChangeSelectedLayer(null))
            toggleDisplay('preview')
        }
    }

    const backToProductList = () => {
        const confirmed = window.confirm('Changes you made may not be saved.')
        if (confirmed) {
            if (mappingProductId) {
                navigate(`/mapping-variants/${mappingProductId}?variantId=${variantId}`)
            }
            else if (isBackofficeEnv()) {
                window.open(`${process.env.REACT_APP_BASE_URL}/a/products/mockup-generator/variants`, '_self')
            } else {
                window.open(`${process.env.REACT_APP_WEBSITE_URL}/product/${productDetail.slug}`, '_self')
            }
        }
    }

    const handleClickNextBtn = () => {
        switchPreview()
    }

    const handleNavigate = () => {
        if (mappingProductId) {
            backToMapping()
            return
        }
        return isPreviewStep || isPricingStep ? toggleDisplay('design') : backToProductList()
    }

    const backToMapping = () => {
        navigate(`/mapping-variants/${mappingProductId}?variantId=${variantId}`, {replace: true})
    }

    const renderSaveButton = () => {
        if (mappingProductId && mappingProduct) {
            let variant = product.variants?.find((v) => v.sku === sku)
            if (!variant) {
                variant = mappingProduct.variant
            }
            let title = variant.attributes?.map((opt) => opt.value_text).join(' / ') || ''
            let color = null
            const colorOption = variant?.attributes?.find((attr) => attr.type === 'color')
            if (colorOption) {
                color = colorOption.color_code || colorOption.value_code
            }
            return (
                <Fragment>
                    <StepIndicator activeStep={2} />
                    <div className="attribute" id="variant-info-tooltip">
                        Variant:&nbsp;
                        {color && <span className="colorPreview" style={{'--bg-color': color}} />}
                        <span className="variant">{title || ''}</span>
                        <span className="price">${variant.base_cost || 0}</span>
                    </div>
                    <Tooltip
                        placement="bottom"
                        isOpen={tooltipOpen}
                        target="variant-info-tooltip"
                        toggle={toggleTooltip}
                    >
                        {title || 'No variant title'}
                    </Tooltip>
                    <Publish disabled={!hasLayers}/>
                </Fragment>
            )
        }
        return (
            <Fragment>
                {isDesignStep &&
                productCreatedType !== 'regularHasTemplate' &&
                productCreatedType !== 'regularNoTemplate' ? (
                    <button
                        id={'header_next_btn'}
                        type={'button'}
                        className={'Design btn btn-primary flex-center rounded'}
                        disabled={runningImageCompress || !hasLayers || cropMode}
                        onClick={handleClickNextBtn}
                    >
                        Next <ChevronRight className={'ms-1'} />
                    </button>
                ) : (
                    <Publish />
                )}
            </Fragment>
        )
    }

    return (
        <div className="NavBar2 no-gutters">
            <div className="Left col-4 text-left d-flex align-items-center">
                {
                    isPreviewStep || isPricingStep || mappingProductId ? (
                        <span className='PrevStep cursor-pointer flex-center' onClick={handleNavigate}>
                            <span className='Icon'>
                                <ArrowBack />
                            </span>
                            {
                                mappingProductId ? (
                                    <span className={'text-primary'}>Select variant</span>
                                ) : isPreviewStep || isPricingStep ? (
                                    <span className={'text-primary'}>Design</span>
                                ) : (
                                    <a href='/'>Product</a>
                                )
                            }
                        </span>
                    ) : (
                        <a href="/" className='PrevStep cursor-pointer flex-center text-primary text-decoration-none'>
                            <span className='Icon'>
                                <ArrowBack />
                            </span>
                            Product
                        </a>
                    )
                }
                <div className={'vr mx-3'} />
                <h6 className={'fw-500 mb-0'}>{productDetail.title}</h6>
                {/*<ChangeProductButton/>*/}
            </div>

            <div className='Right col-8'>
                <div className={'d-flex justify-content-end'}>
                    {renderSaveButton()}
                </div>
            </div>
        </div>
    )
}

export default NavBar



